/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonArticleInfo,
    JsonArticleInfoFromJSON,
    JsonArticleInfoFromJSONTyped,
    JsonArticleInfoToJSON,
} from './JsonArticleInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonArticleInfo
 */
export interface ApiResultOfJsonArticleInfo {
    /**
     * 
     * @type {JsonArticleInfo}
     * @memberof ApiResultOfJsonArticleInfo
     */
    data?: JsonArticleInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonArticleInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonArticleInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonArticleInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonArticleInfo
     */
    result?: ApiResultOfJsonArticleInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonArticleInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonArticleInfoFromJSON(json: any): ApiResultOfJsonArticleInfo {
    return ApiResultOfJsonArticleInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonArticleInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonArticleInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonArticleInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonArticleInfoToJSON(value?: ApiResultOfJsonArticleInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonArticleInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

